// ExecutionLog — Auto-execution history (Angel One light theme)
import React from 'react';
import { FaCheckCircle, FaTimesCircle, FaBell } from 'react-icons/fa';

export default function ExecutionLog({ entries }) {
  if (!entries || entries.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-8 text-center text-xs text-gray-400">
        No execution history yet
      </div>
    );
  }

  const getStatusStyles = (status) => {
    if (status === 'executed') return { icon: FaCheckCircle, color: 'text-green-600' };
    if (status === 'failed') return { icon: FaTimesCircle, color: 'text-red-500' };
    return { icon: FaBell, color: 'text-blue-600' };
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
      <div className="grid grid-cols-12 gap-2 px-4 py-2.5 text-[10px] font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-200 bg-gray-50">
        <div className="col-span-2">Time</div>
        <div className="col-span-2">Strategy</div>
        <div className="col-span-2">Symbol</div>
        <div className="col-span-1">Action</div>
        <div className="col-span-2">Status</div>
        <div className="col-span-3">Details</div>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {entries.map((entry, i) => {
          const { icon: StatusIcon, color } = getStatusStyles(entry.status);
          const isBuy = entry.action === 'BUY' || entry.action === 'EXIT_SHORT';
          return (
            <div key={entry.id || i} className="grid grid-cols-12 gap-2 px-4 py-2.5 border-b border-gray-50 hover:bg-gray-50 text-[11px]">
              <div className="col-span-2 text-gray-400">
                {entry.timestamp?.split('T')[1]?.slice(0, 8) || '—'}
              </div>
              <div className="col-span-2 text-gray-700 font-medium">{entry.strategyName}</div>
              <div className="col-span-2 text-gray-900 font-semibold">{entry.instrument?.symbol}</div>
              <div className="col-span-1">
                <span className={`font-bold ${isBuy ? 'text-green-600' : 'text-red-500'}`}>
                  {entry.action}
                </span>
              </div>
              <div className="col-span-2 flex items-center gap-1">
                <StatusIcon className={`${color} text-[9px]`} />
                <span className={`${color} capitalize`}>{entry.status}</span>
              </div>
              <div className="col-span-3 text-gray-500 truncate">
                {entry.orderId ? `Order #${entry.orderId}` : entry.message || '—'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
